import {
  fetchAllVisibleLayouts,
  fetchAllLayouts,
  fetchLayout,
  updateLayout,
  postLayout,
} from '../../actions/layout/apiRequests';
import { notifyInfo, notifyError } from '../../utils/notifier';

const serialize = (data) => ({
  ...data,
  layout: JSON.stringify(data.layout, null, '\t'),
});

export const fetchLayouts = (setLoading) => {
  setLoading(true);

  return fetchAllLayouts()
    .then((data) => data.map((option) => serialize(option)))
    .catch(() => {
      setLoading(false);
      notifyError();
    });
};

export const fetchVisibleLayouts = (setLoading) => {
  setLoading(true);

  return fetchAllVisibleLayouts()
    .then((data) => data.map((option) => serialize(option)))
    .catch(() => {
      setLoading(false);
      notifyError();
    });
};

export const fetchLayoutById = (id, setLoading) => {
  setLoading(true);

  return fetchLayout(id)
    .then((data) => serialize(data))
    .catch(() => {
      setLoading(false);
      notifyError();
    });
};

export const save = (layout, isNew = false) => {
  const request = isNew ? postLayout(layout) : updateLayout(layout.id, layout);

  return request
    .then(() => notifyInfo())
    .catch((e) => {
      let message;

      if (e.response.errors.layout) {
        message = 'Cannot deserialize the JSON object into Layout';
      } else {
        message = Object.keys(e.response.errors)
          .map((key) => `${key}: ${e.response.errors[key]}`)
          .join('; ');
      }

      notifyError(message);
      throw e;
    });
};

export const validateForm = (form) => {
  try {
    const layout = JSON.parse(form.layout);
    return Array.isArray(layout);
  } catch (error) {
    return false;
  }
};



// WEBPACK FOOTER //
// src/components/LayoutManagement/utils.js